import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { Ask } from "./pages/Ask";
import { NotFound } from "./pages/NotFound";
import { Root } from "./pages/Root";

export const AppRoutes: React.FC = () => {
  const location = useLocation();
  const prevLocationRef = React.useRef(location.pathname);
  if (location.pathname !== prevLocationRef.current) {
    window.scrollTo(0, 0);
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/ask" element={<Ask />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
